import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getDetailData, updateMessageData } from '../../../../../api';
import SeekList from './SeekList/SeekList';
import { TAGS } from '../../../../../content';
import {
  ROUTE,
  CONTENT_TYPE,
  VIDEO_EVENT,
  PATH,
} from '../../../../../constants';
import Discussion from './Discussion/Discussion';
import MessageBlock from './MessageBlock/MessageBlock';
import DetailVideo from './DetailVideo/DetailVideo';
import DetailPhoto from './DetailPhoto/DetailPhoto';
import SendOverlay from './SendOverlay/SendOverlay';
import './Detail.css';
import { MsgCountContext } from '../../../../../context';
import { formatNameText } from '../../../../../utils/TextHelper';

class Detail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // forms
      sending: false,
      // video
      videoStarted: false,
      videoPlaying: false,
    };

    this.messageRef = React.createRef();
    this.videoRef = React.createRef();

    this.handleFormSend = this.handleFormSend.bind(this);
    this.handleSendClose = this.handleSendClose.bind(this);
    this.handleVideoUpdate = this.handleVideoUpdate.bind(this);
    this.handleVideoSwitch = this.handleVideoSwitch.bind(this);
    this.handleVideoPause = this.handleVideoPause.bind(this);
    this.handleVideoSeek = this.handleVideoSeek.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Lifecycle
  // -----------------------------------------------------------------------------------

  componentDidUpdate(prevProps) {
    const { match } = this.props;
    if (match.params.detailId !== prevProps.match.params.detailId) {
      this.resetVideo();
    }
  }

  // -----------------------------------------------------------------------------------
  // Helpers
  // -----------------------------------------------------------------------------------

  getVideoTime() {
    let videoTime = 0;
    if (this.videoRef.current) {
      // note - revise extensive refs usage - works but not really clean approach
      videoTime = this.videoRef.current.getVideoTime();
    }
    return videoTime;
  }

  resetVideo() {
    // reset video state if id is switched by url change (edge case)
    this.setState({
      videoStarted: false,
      videoPlaying: false,
    });
  }

  // -----------------------------------------------------------------------------------
  // Forms
  // -----------------------------------------------------------------------------------

  handleFormSend(value) {
    const { match } = this.props;
    // update message data
    updateMessageData(
      value,
      match.params.categoryId,
      match.params.detailId,
      this.getVideoTime()
    );
    // start saving
    this.setState({
      sending: true,
    });
  }

  handleSendClose(doReset) {
    this.setState({
      sending: false,
    });
    if (doReset) {
      // note - check if ideal - at least doesn't update whole tree like top state
      this.messageRef.current.resetMessage();
    }
  }

  // -----------------------------------------------------------------------------------
  // Handlers
  // -----------------------------------------------------------------------------------

  handleVideoUpdate(type, value) {
    switch (type) {
      case VIDEO_EVENT.STARTED:
        this.setState({
          videoStarted: value,
        });
        break;
      case VIDEO_EVENT.PLAYING:
        this.setState({
          videoPlaying: value,
        });
        break;
      default:
    }
  }

  handleVideoSwitch() {
    const { videoPlaying } = this.state;
    if (videoPlaying) {
      this.videoRef.current.pauseVideo();
    } else {
      this.videoRef.current.playVideo();
    }
  }

  handleVideoPause() {
    if (this.videoRef.current) {
      this.videoRef.current.pauseVideo();
    }
  }

  handleVideoSeek(add, value) {
    const { videoStarted } = this.state;
    if (!add && !videoStarted) {
      // play and seek - on seek thumb click before video is active
      this.videoRef.current.playVideo(value);
    } else {
      this.videoRef.current.seekVideo(add, value);
    }
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  render() {
    const { sending, videoStarted, videoPlaying } = this.state;
    const { match } = this.props;
    const { categoryId, detailId } = match.params;

    const categoryName = TAGS[categoryId];
    const detailData = getDetailData(detailId);

    return (
      <div id="detail">
        <div id="detail-wrap">
          <div id="detail-left">
            {categoryName !== undefined && (
              <Link to={`${ROUTE.CATEGORY}/${categoryId}`}>
                <img
                  id="detail-left-title"
                  src={`${PATH.IMG}title/${categoryId}.png`}
                  alt={categoryName}
                />
              </Link>
            )}
            <h2 id="detail-name">{formatNameText(detailData.name)}</h2>

            <div id="detail-content-wrap">
              <img
                className="dcd-t t-0"
                src={`${PATH.IMG}deco/video-top-0.png`}
                alt=""
              />
              <img
                className="dcd-t t-1"
                src={`${PATH.IMG}deco/video-top-1.png`}
                alt=""
              />
              <img id="dcd-c" src={`${PATH.IMG}deco/video-center.png`} alt="" />
              {detailData.type === CONTENT_TYPE.VIDEO && (
                <DetailVideo
                  detailId={detailId}
                  ref={this.videoRef}
                  videoStarted={videoStarted}
                  onVideoUpdate={this.handleVideoUpdate}
                />
              )}
              {detailData.type === CONTENT_TYPE.PHOTO && (
                <DetailPhoto detailId={detailId} />
              )}

              <div id="detail-right">
                <MessageBlock
                  ref={this.messageRef}
                  formSend={this.handleFormSend}
                  videoStarted={videoStarted}
                  videoPlaying={videoPlaying}
                  videoControls={detailData.type === CONTENT_TYPE.VIDEO}
                  onVideoSwitch={this.handleVideoSwitch}
                  onVideoPause={this.handleVideoPause}
                  onVideoSeek={this.handleVideoSeek}
                />
              </div>
            </div>

            <MsgCountContext.Consumer>
              {msgCount => (
                <Discussion
                  detailId={detailId}
                  msgCount={msgCount[detailId]}
                  onVideoSeek={this.handleVideoSeek}
                />
              )}
            </MsgCountContext.Consumer>
          </div>

          {detailData.type === CONTENT_TYPE.VIDEO && (
            <SeekList detailId={detailId} onVideoSeek={this.handleVideoSeek} />
          )}

          <div id="detail-mobile-back">
            <Link to="/">
              <img src={`${PATH.IMG}ico/mobile-back.png`} alt="" />
            </Link>
          </div>

          {sending && <SendOverlay sendClose={this.handleSendClose} />}
        </div>
      </div>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/Detail.js